module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MEwoJp/tc-custom/9781937560423.jpg?1700070699517",
      "alt": "This image is the cover for the book The Hitchhiker’s Guide to Manufacturing Operations Management: ISA-95 Best Practices Book 1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Hitchhiker’s Guide to Manufacturing Operations Management: ISA-95 Best Practices Book 1.0\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Do you want to dramatically lower total cost of ownership (TCO) for manufacturing IT architectures and manufacturing, as well as reduce supply chain operational costs? The methodologies and technical applications presented in this first annual ISA-95/MESA Best Practices book will help get you started on the right track. This book provides in-depth coverage on how you can apply ISA-95, Enterprise-Control Integration Standard, to help lower TCO of manufacturing operations management (MOM) systems and their enterprise and plant interfaces. It consists of a series of related “how-to” white papers described in the context of ISA-95 models, definitions, and data exchanges. To be competitive, actual manufacturing operations activities must be highly interactive in supply chain and enterprise processes for effective collaboration and competition. This is the domain of collaborative and flexible MOM system architectures. This book explains the business cases for using evolving ISA-95 methods to effectively design, implement, change and optimize the MOM business processes and supporting MOM system architectures within the distributed pull supply chains.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlie Gifford\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ISA\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0